import { render, staticRenderFns } from "./InfoguidancePage.vue?vue&type=template&id=6e7bb6d2&scoped=true&"
import script from "./InfoguidancePage.vue?vue&type=script&lang=js&"
export * from "./InfoguidancePage.vue?vue&type=script&lang=js&"
import style0 from "./InfoguidancePage.vue?vue&type=style&index=0&id=6e7bb6d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7bb6d2",
  null
  
)

/* custom blocks */
import block0 from "./InfoguidancePage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports